<script setup>

import { ref, watch, onMounted } from 'vue';

const { dimension, selectionnee } = defineProps({
  dimension: Object,
  selectionnee: Boolean
});

const composant = ref(null);

watch(() => selectionnee, (sel) => {
	if (sel) {
		composant.value.scrollIntoView({behavior: "smooth", block: "nearest"});
	}
});

onMounted(() => {
	if (composant.value != null && selectionnee) {
		composant.value.scrollIntoView({behavior: "smooth", block: "nearest"});
	}
});

function commencerGlisserDeplacer(event) {
	const donneesTransfert = {
		type: 'CHAMPS',
		champs: [dimension]
	};
	event.dataTransfer.setData('text/plain', JSON.stringify(donneesTransfert));
	event.dataTransfer.dropEffect = 'copy';
}

</script>

<template>
	<div class="dimension" 
		ref="composant"
		draggable="true"
		@dragstart="commencerGlisserDeplacer">
		<div class="nom-dimension">{{ dimension.nom }}</div>
		<i v-if="dimension.formuleEnErreur" class="fa-solid fa-triangle-exclamation icone erreur" v-tooltip="'Dimension en erreur'" />
		<i v-else class="icone invisible" />
	</div>
</template>

<style scoped>

.dimension {
	display: flex;
	user-select: none;
	padding: 0px 5px;
	align-items: center;
}

.nom-dimension {
	width: 14rem;
	overflow: hidden;
	text-overflow: ellipsis;
	flex-grow: 1;
}

.icone {
	padding: 1px;
	margin: 2px 4px;
	width: 1rem;
	text-align: center;
}

.erreur {
	color: var(--couleur-valeur-en-erreur);
}

</style>